import client from '../client';
import type { InventoryItem, InventoryStats } from '../../types/inventory';
import type { ApiResponse, PaginationParams } from '../../types/api';

interface InventoryListParams extends PaginationParams {
  filter?: 'all' | 'low' | 'out';
  search?: string;
}

export const inventoryApi = {
  list: async (storeId: string, params?: InventoryListParams) => {
    const res = await client.get<ApiResponse<{ items: InventoryItem[]; stats: InventoryStats; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/inventory`,
      { params },
    );
    return res.data.data!;
  },

  updateStock: async (storeId: string, productId: string, quantity: number) => {
    await client.patch(`/dashboard/${storeId}/inventory/${productId}`, { quantity });
  },

  updateVariantStock: async (storeId: string, productId: string, variantId: string, quantity: number) => {
    await client.patch(`/dashboard/${storeId}/inventory/${productId}/variants/${variantId}`, { quantity });
  },
};
